// MerchantContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { loginResponseSaga } from './redux/saga/loginServiceSelector';

const MerchantContext = createContext();

export const MerchantProvider = ({ children }) => {
  const loginResponseData = useSelector(loginResponseSaga);
  const [merchantData, setMerchantData] = useState(() => {
    return {
      merchantId: sessionStorage.getItem('merchantId') || null,
      aggregator: sessionStorage.getItem('aggregator') || null,
      emailId: sessionStorage.getItem('emailId') || null,
      isAdmin: sessionStorage.getItem('isAdmin') === 'true',
      userName: sessionStorage.getItem('userName') || null,
	  merchantName: sessionStorage.getItem('merchantName') || null,
    };
  });

  useEffect(() => {
    if (loginResponseData) {
      const newMerchantData = {
        merchantId: loginResponseData.merchantId,
        aggregator: loginResponseData.aggregator,
        emailId: loginResponseData.emailId,
        isAdmin: loginResponseData.isAdmin,
        userName: loginResponseData.userName,
		merchantName : loginResponseData.merchantName || sessionStorage.getItem('merchantName')
      };

      setMerchantData(newMerchantData);
      sessionStorage.setItem('merchantId', newMerchantData.merchantId);
	  sessionStorage.setItem('merchantName', newMerchantData.merchantName);
    }
  }, [loginResponseData]);

  useEffect(() => {
    if (merchantData.merchantId) {
      sessionStorage.setItem('merchantId', merchantData.merchantId);
    }
	if (merchantData.merchantName) {
		sessionStorage.setItem('merchantName', merchantData.merchantName);
	}
  }, [merchantData]);

  return (
    <MerchantContext.Provider value={{ ...merchantData, setMerchantData }}>
      {children}
    </MerchantContext.Provider>
  );
};

export const useMerchant = () => {
  return useContext(MerchantContext);
};
